<template>
  <div class="certificate-wrapper">
    <img class="certificate-image" :src="image" crossOrigin="anonymous" alt="">
    <div class="explain">长按可以保存图片进行分享哦！</div>
    <div ref="certificate" class="certificate">
      <div class="title">
        <div class="score-wrapper">
          <span class="score">{{score}}</span>
          <span>分</span>
        </div>
        <div class="word-wrapper">
          本节课我已完全掌握
        </div>
        <div class="power">为梦想奋斗</div>
      </div>
      <div class="main">
        <div class="school">{{schoolName}}</div>
        <div class="name">{{name}}</div>
        <div class="finished">
          恭喜你完成了
          <span class="primary">【{{courseName}}-{{unitName}}】</span>
        </div>
        <div class="energy">请保持学霸速度，继续挑战！</div>
      </div>
      <img class="qrcode" :src="qrcode" crossOrigin="anonymous" alt="" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import utils from '@/services/utils';
import api from '@/api/graphql/englishCourse';
import html2canvas from 'html2canvas';

export default {
  components: {
  },
  data() {
    return {
      name: '',
      schoolName: '',
      courseName: '',
      unitName: '',
      score: '',
      wordCount: '',
      image: '',
      qrcode: '',
      id: '',
      mode: 'default'
    };
  },
  computed: {
  },
  created() {
    document.addEventListener('WeixinJSBridgeReady', () => {  
        // 发送给好友
        WeixinJSBridge.call('hideOptionMenu');
    }, false);
    if (decodeURIComponent(utils.params('course_name')) !== 'null') {
      // 兼容url携带信息
      this.mode = 'compatible';
      this.courseName = decodeURIComponent(utils.params('course_name'));
      this.name = decodeURIComponent(utils.params('name'));
      this.schoolName = decodeURIComponent(utils.params('school_name'));
      this.wordCount = decodeURIComponent(utils.params('word_count'));
      this.score = decodeURIComponent(utils.params('score'));
      this.unitName = decodeURIComponent(utils.params('unit_name'));
      this.qrcode = decodeURIComponent(utils.params('qrcode'));      
    } else {
      const examId = decodeURIComponent(utils.params('exam_id'));
      const userId = decodeURIComponent(utils.params('user_id'));
      this.fetchCertificateInfo(examId, userId);
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.mode === 'compatible') {
        this.getImage();
      }
    });
  },
  methods: {
    getImage() {
      html2canvas(this.$refs.certificate, {
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true,//允许跨域图片
      }).then((canvas) => {
        // 转成图片，生成图片地址
        this.image = canvas.toDataURL('image/png');
      });
    },
    fetchCertificateInfo(examId, userId) {
      api.getExamDetail({
        examId,
        userId,
        type: 'share',
      }).then(({ englishExamDetail }) => {
        const { name, schoolName, courseName, unitName, score, wordCount, qrcode } = englishExamDetail;
        this.name = name;
        this.schoolName = schoolName;
        this.courseName = courseName;
        this.unitName = unitName;
        this.score = score;
        this.wordCount = wordCount;
        this.qrcode = qrcode;
        this.$nextTick(() => {
          this.getImage();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .certificate-wrapper {
    width: 100%;
    height: 100%;
    .certificate-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99;
    }
    .explain {
      position: absolute;
      bottom: 20px;
      width: 100%;
      color: #333;
      font-size: 16px;
      text-align: center;
      z-index: 100;
    }
    .certificate {
      position: relative;
      width: 100%;
      height: 100%;
      background-image: url('../../assets/background.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      overflow-y: auto;
      .title {
        position: relative;
        top: 10%;
      }
      .score-wrapper {
        margin-top: 8%;
        text-align: center;
        color: $danger;
        font-size: 40px;
        .score {
          font-size: 100px;
        }
      }
      .word-wrapper {
        margin: 10px auto 20px;
        padding: 10px 20px;
        width: 70%;
        font-size: 20px;
        text-align: center;
        background-color: #ffd732;
        font-weight: 700;
        color: #5e1c16;
        letter-spacing: 2px;
        .word {
          color: $danger;
        }
      }
      .power {
        color: #5e1c16;
        text-align: center;
        font-size: 24px;
        letter-spacing: 14px;
      }
      .main {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        // margin: 90px auto 0;
        padding: 20px;
        border-radius: 5px;
        width: 94%;
        opacity: .9;
        background-color:#f2fbf5;
        .school {
          font-size: 28px;
          font-weight: 700;
        }
        .name {
          margin-top: 15px;
          font-size: 28px;
          font-weight: 700;
        }
        .finished {
          margin-top: 10px;
          font-size: 18px;
          word-break: break-all;
          .primary {
            color: $primary;
          }
        }
        .energy {
          margin-top: 10px;
          font-size: 18px;
        }
      }
      .qrcode {
        position: absolute;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 80px;
      }
    }
  }
</style>
